/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reference_Request_FailedInputs */

const fr_reference_request_failed = /** @type {(inputs: Reference_Request_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cette action n’a pas abouti. Réessayez.`)
};

const en_reference_request_failed = /** @type {(inputs: Reference_Request_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not complete this action. Try again.`)
};

/**
* | output |
* | --- |
* | "Could not complete this action. Try again." |
*
* @param {Reference_Request_FailedInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const reference_request_failed = /** @type {((inputs?: Reference_Request_FailedInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reference_Request_FailedInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_reference_request_failed(inputs)
	return fr_reference_request_failed(inputs)
});